import React from 'react';
import { Loader2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { TERMINAL_STATUSES, type JobStatus } from '@/types/training';

const PRESENTATION: Record<JobStatus, { label: string; tone: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
  created: { label: 'Created', tone: 'outline' },
  queued: { label: 'Queued', tone: 'secondary' },
  allocating_runpod: { label: 'Allocating node', tone: 'secondary' },
  runpod_starting: { label: 'Node booting', tone: 'secondary' },
  worker_booting: { label: 'Worker booting', tone: 'secondary' },
  downloading_dataset: { label: 'Downloading data', tone: 'secondary' },
  preprocessing: { label: 'Preprocessing', tone: 'secondary' },
  training: { label: 'Training', tone: 'default' },
  evaluating: { label: 'Evaluating', tone: 'default' },
  uploading_artifacts: { label: 'Uploading', tone: 'default' },
  shutting_down_runpod: { label: 'Releasing node', tone: 'secondary' },
  completed: { label: 'Completed', tone: 'default' },
  failed: { label: 'Failed', tone: 'destructive' },
  cancelled: { label: 'Cancelled', tone: 'outline' },
};

export default function JobStatusBadge({ status, showSpinner = true }: { status: JobStatus; showSpinner?: boolean }) {
  const p = PRESENTATION[status] || { label: status, tone: 'outline' as const };
  const isActive = !TERMINAL_STATUSES.includes(status);
  return (
    <Badge variant={p.tone} className="inline-flex items-center gap-1.5">
      {isActive && showSpinner && <Loader2 className="h-3 w-3 animate-spin" aria-hidden />}
      {p.label}
    </Badge>
  );
}
